/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonProductInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class PersonProductApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'PersonProducts');
  }

  deletePersonProduct(personProductId: number): Observable<PersonProductInterface> {
    const path = `${personProductId}`;
    return this.delete<PersonProductInterface>(path);
  }

  deletePersonProducts(personProductIds: number[]): Observable<PersonProductInterface[]> {
    const path = `deletePersonProducts`;
    const body = personProductIds;
    return this.post<PersonProductInterface[]>(path, undefined, body);
  }

  createPersonProduct(personProduct: any): Observable<PersonProductInterface> {
    const path = `createPersonProduct`;
    const body = personProduct;
    return this.post<PersonProductInterface>(path, undefined, body);
  }

  createPersonProducts(personProducts): Observable<PersonProductInterface[]> {
    const path = `createPersonProducts`;
    const body = personProducts;
    return this.post<PersonProductInterface[]>(path, undefined, body);
  }
}
